import { Config } from 'config'

const config: Partial<Config> = {
  env: 'dev',
  basePath: '/site/',
  basename: '/site',
  routerPath: '/*',
  api: {
    url: '/bff',
  },
}

export default config as Config
